export const Translations = {
  'en': {
    'cardNumberLabel': 'Card Number',
    'cardNumberPlaceholder': 'Add new card number',
    'cardholderNameLabel': 'Cardholder\'s Name',
    'cardholderNamePlaceholder': 'Add cardholder Name',
    'noCardholderNameErrorMessage': 'Card holder name is blank.',
    'duplicateCardNumbersErrorMessage': 'The same scan card number has been used more than once.',
    'invalidCardNumberErrorMessage': 'Scan Card number is invalid. Please re-enter.'
  }
}
